<template>
<div class="nationalDistributionHeader box-shadow">
    <el-header class="header">
        <el-breadcrumb separator="/" class="breadcrumb-inner">
            <el-breadcrumb-item v-for="(item) in $route.matched" :key="item.name" :to="item.path"
                                style="cursor: pointer">
                <span>{{item.meta.title}}</span>
            </el-breadcrumb-item>
        </el-breadcrumb>
        <div class="userInfo">
            <div class="info settings">
                <span @click="goToHome"><i class="el-icon-arrow-left"></i>返回鲸客通</span>
            </div>
        </div>
    </el-header>
</div>
</template>

<script>
import {getUnreadNoticeList, setNoticeStatus} from 'api/api'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'nationalDistributionHeader',
    data() {
        return {
            unreadNoticeList: [],
            number: 0
        }
    },
    mounted() {
        this._getUnreadNoticeList()
    },
    methods: {
        handelEditStatus(row) {
            this.setLoading(true)
            setNoticeStatus({
                data: {
                    innerid: row.innerid
                },
                success: data => {
                    this.$message.success(data.msg)
                    this.setLoading(false)
                    this._getUnreadNoticeList()
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        _getUnreadNoticeList() {
            getUnreadNoticeList({
                data: {},
                success: data => {
                    this.number = data.data.number
                    this.unreadNoticeList = data.data.content
                },
                error: data => {
                    this.$message.error(data.msg)
                }
            })
        },
        goToMgt() {
            alert('主办方管理后台')
        },
        goToNotice() {
            this.$router.push({name: 'NoticeList'})
        },
        goToHome() {
            this.$router.push({name: 'Index'})
        },
        esc() {
            window.sessionStorage.clear()
            this.$router.push('Login')
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'user'
        ])
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/variable";
@import "~common/scss/mixin";

.nationalDistributionHeader {
    .header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: $font-14;
        height: 50px !important;
        color: $tcolor-gray;
        background-color: $bgcolor-white;
        .userInfo {
            display: flex;
            .info {
                margin-left: 30px;
                display: flex;
                align-items: center;
                .icon, img {
                    padding: 4px 5px;
                    width: 18px;
                    height: 20px;
                    display: inline-block;
                    margin-right: 5px;
                }
            }
            .message {
                position: relative;
                .item {
                    cursor: pointer;
                    &:hover {
                        color: $tcolor-blue;
                    }
                }
                .el-popover__reference {
                    @include flexBox(center);
                }
            }
        }
    }
}

.wHeader-dropdown {
    .el-dropdown-menu__item {
        @include flexBox(flex-start);
        .icon {
            padding: 4px 5px;
            width: 18px;
            height: 20px;
        }
    }
}

.el-popover {
    padding: 0;
    .wHeader-popover {
        .nomessage {
            padding: 8px 12px;
            text-align: center;
            height: 50px;
            color: $tcolor-lightgrey;
        }
        .message-info {
            padding: 8px 12px;
            font-size: $font-14;
            color: $tcolor-base;
            &:hover {
                background: $bgcolor-lightbase;
                .message-info-btn {
                    display: block;
                    cursor: pointer;
                }
            }
            .message-info-detail {
                @include flexBox(space-between);
                margin-bottom: 5px;
            }
            .message-info-btn {
                @include flexBox(center);
                display: none;
                color: $tcolor-blue;
                font-size: $font-12;
            }
            .date-time {
                color: $tcolor-grey;
                font-size: $font-12;
            }
        }
        .message-info ~ .message-info {
            border-top: 1px solid $line;
        }
    }
}
</style>
